import type { ComplianceLimit } from "./types";

export function formatLimit(item: ComplianceLimit) {
  const unit = item.unidad ? ` ${item.unidad}` : "";
  if (item.tipo_criterio === "minimo") return `${item.minimo_incluyente === false ? ">" : "≥"} ${item.valor_minimo ?? "—"}${unit}`;
  if (item.tipo_criterio === "maximo") return `${item.maximo_incluyente === false ? "<" : "≤"} ${item.valor_maximo ?? "—"}${unit}`;
  if (item.tipo_criterio === "rango") return `${item.minimo_incluyente === false ? "(" : "["}${item.valor_minimo ?? "—"} – ${item.valor_maximo ?? "—"}${item.maximo_incluyente === false ? ")" : "]"}${unit}`;
  if (item.tipo_criterio === "objetivo") return `Valor objetivo: ${item.valor_objetivo ?? "—"}${unit}${item.tolerancia_inferior != null || item.tolerancia_superior != null ? ` (−${item.tolerancia_inferior ?? 0} / +${item.tolerancia_superior ?? 0})` : ""}`;
  return item.criterio_textual || "Criterio textual no especificado";
}

export function qualityError(error: unknown) {
  const source = error && typeof error === "object" ? error as Record<string, unknown> : {};
  const code = String(source.code || source.status || "");
  const message = String(source.message || (error instanceof Error ? error.message : ""));
  if (code === "42501" || code === "403" || /permission|permiso|authorized/i.test(message)) return "No tienes permisos para realizar esta operación.";
  if (code === "23505") return "Este registro ya existe.";
  if (code === "23503") return "El registro está relacionado con otros elementos.";
  if (code.startsWith("PGRST")) return "Error de comunicación con el servidor.";
  return message || "No fue posible completar la operación.";
}
